// Defensywny helper trendu dostępności. Nie interpretuje treści availability —
// strzałka góra/dół tylko dla czysto liczbowych wartości, inaczej neutralny wskaźnik.
import i18n from '../i18n';

export const AVAILABILITY_TREND_MIN_DELTA = 0.1;

const hasValue = (v) => v !== null && v !== undefined && String(v).trim() !== '';

const isPureNumeric = (v) => hasValue(v) && /^\d+$/.test(String(v).trim());

// Używamy komponentów UTC, żeby data w tooltipie zawsze zgadzała się z datą
// zapisaną w ISO timestampie z API, niezależnie od strefy czasowej przeglądarki.
const safeFormatDate = (ts) => {
  if (!hasValue(ts)) return null;
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return null;
  const yyyy = d.getUTCFullYear();
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const formatEntry = (value, ts) => {
  if (!hasValue(value)) return null;
  const date = safeFormatDate(ts);
  return date ? `${String(value).trim()} (${date})` : String(value).trim();
};

const buildTooltip = (prev, prevTs, prev2, prev2Ts) => {
  const lines = [];
  const prevEntry = formatEntry(prev, prevTs);
  if (prevEntry) lines.push(i18n.t('model:oferta.trend_poprzednio', { wpis: prevEntry }));
  const prev2Entry = formatEntry(prev2, prev2Ts);
  if (prev2Entry) lines.push(i18n.t('model:oferta.trend_wczesniej', { wpis: prev2Entry }));
  return lines.length ? lines.join('\n') : null;
};

const NONE = { shouldShow: false, direction: null, tooltipText: null };

export const getAvailabilityTrend = ({
  availability,
  availability_prev,
  availability_prev_ts,
  availability_prev2,
  availability_prev2_ts,
} = {}) => {
  if (!hasValue(availability) || !hasValue(availability_prev)) return NONE;

  const current = String(availability).trim();
  const prev = String(availability_prev).trim();
  const tooltipText = buildTooltip(availability_prev, availability_prev_ts, availability_prev2, availability_prev2_ts);

  if (isPureNumeric(current) && isPureNumeric(prev)) {
    const currentN = parseInt(current, 10);
    const prevN = parseInt(prev, 10);
    if (currentN === prevN) return NONE;
    const pctChange = prevN === 0 ? 1 : (currentN - prevN) / prevN;
    if (Math.abs(pctChange) < AVAILABILITY_TREND_MIN_DELTA) return NONE;
    return { shouldShow: true, direction: pctChange > 0 ? 'up' : 'down', tooltipText };
  }

  if (current === prev) return NONE;
  return { shouldShow: true, direction: 'neutral', tooltipText };
};
